import axios from 'axios';

export interface AppData {
  trackId: number;
  trackName: string;
  description: string;
  averageUserRating: number;
  userRatingCount: number;
  artworkUrl512: string;
  screenshotUrls: string[];
  sellerName: string;
  version: string;
  currentVersionReleaseDate: string;
  primaryGenreName: string;
  bundleId: string;
  trackViewUrl: string;
}

export const fetchApps = async (developerId: string): Promise<AppData[]> => {
  try {
    const response = await axios.get(
      `https://itunes.apple.com/lookup?id=${encodeURIComponent(developerId)}&entity=software&country=us`
    );
    
    if (response.data.results) {
      // First result is usually the developer, so we filter it out
      return response.data.results.filter((app: AppData) => app.trackId !== undefined);
    }
    
    return [];
  } catch (error) {
    console.error('Error fetching apps:', error);
    return [];
  }
};

export const searchAppsByDeveloper = async (developerName: string): Promise<AppData[]> => {
  try {
    // Clean up the developer name
    const cleanDeveloperName = developerName.trim().replace(/\s+/g, '+');
    
    // First try searching by developer name
    const searchUrl = `https://itunes.apple.com/search?term=${encodeURIComponent(cleanDeveloperName)}&media=software&entity=software&country=us&limit=200`;
    
    const response = await axios.get(searchUrl);
    
    if (response.data.results && response.data.results.length > 0) {
      // Filter results to match the exact developer name (case insensitive)
      return response.data.results.filter((app: AppData) => 
        app.sellerName && 
        app.sellerName.toLowerCase() === developerName.toLowerCase()
      );
    }
    
    // If no results, try a more general search
    const fallbackUrl = `https://itunes.apple.com/search?term=${encodeURIComponent(cleanDeveloperName)}&media=software&entity=software&country=us&limit=10`;
    const fallbackResponse = await axios.get(fallbackUrl);
    
    return fallbackResponse.data.results || [];
  } catch (error) {
    console.error('Error searching apps:', error);
    return [];
  }
}; 